module.exports = __webpack_public_path__ + "static/media/paradigm-shift.47235ba4.png";